<template>
  <div class="guide-and-video-info">
    <div class="info-container">
      <span class="title">
        Información de Guía
      </span>
      <custom-file-input
        ref="attachedDocument"
        v-model="value.file"
        class="file-input_extended"
        :attachment-id="guideDocument.itemAttachmentId"
        :name="guideDocument.filename"
        accept=".pdf"
        required
        display-style="normal"
        label-position="left"
        label="Archivo:"
        :max-size="maxGuideConfigFileSizeInMb"
        :on-download="downloadFile"
      />
    </div>
    <div class="info-container">
      <span class="title">
        Información de Video
      </span>
      <custom-input
        v-model="value.videoUrl"
        class="w-100"
        label="URL:"
        :disabled="readonly"
      />
    </div>
    <error v-if="error && error.length" variant="no-border" :message="error" />
  </div>
</template>

<script>
import CustomInput from 'CustomInput';
import CustomFileInput from 'CustomFileInput';
import documentsService from '@/services/documents';
import Error from 'custom-error';
import { getSysparameterByNames } from '@/modules/system-parameter-managment/api';

export default {
  name: 'GuideAndVideoInfo',
  components: { CustomInput, CustomFileInput, Error },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    error: {
      type: String,
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      maxGuideConfigFileSizeInMb: 10,
    };
  },
  computed: {
    guideDocument() {
      return this.value.guideDocument || {};
    },
  },
  mounted() {
    this.getSysParams();
  },
  methods: {
    downloadFile(attachmentId) {
      return documentsService.downloadFromServer(attachmentId);
    },
    async getSysParams() {
      const paramValue = (
        await getSysparameterByNames({
          parameterNames: ['AcademicMaxGuideConfigFileSizeInMb'],
        })
      )?.data[0]?.staticValue;
      if (paramValue) {
        this.maxGuideConfigFileSizeInMb = +paramValue;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables/_colors.scss';

.info-container {
  display: flex;
  align-items: center;
  border-radius: 0.25rem;
  padding: 1rem;
  margin-bottom: 1rem;
  background: map-get($colors, 'secondary-3');
  .title {
    font-weight: bold;
    color: map-get($colors, 'gray-7');
    min-width: 20%;
  }
  .file-input_extended ::v-deep {
    width: 35%;
    .input-label {
      color: map-get($colors, 'gray-6');
      font-weight: normal;
    }
  }
}
</style>
